import {
    anything,
    Arbitrary,
    boolean,
    constantFrom,
    record,
    string,
} from 'fast-check';
import { IDatiqOption } from './datiq-components.interface';
import { DatiqInputTypes } from './datiq-input.enum';
import { IDatiqInput } from './datiq-input.interface';

export const inputRecordModel = {
    id: string(),
    name: string().filter(s => s !== '__proto__'),
    label: string(),
    type: constantFrom(
        DatiqInputTypes.Text,
        DatiqInputTypes.Number,
        DatiqInputTypes.Integer,
        DatiqInputTypes.Currency,
        DatiqInputTypes.Percent,
        DatiqInputTypes.Date,
        DatiqInputTypes.DateRange,
        DatiqInputTypes.Checkbox,
        DatiqInputTypes.Switch,
        DatiqInputTypes.Select,
        DatiqInputTypes.Checklist,
        DatiqInputTypes.Slider,
        DatiqInputTypes.SliderRange,
        DatiqInputTypes.ToggleButton,
        DatiqInputTypes.Geo,
        DatiqInputTypes.Toggle
    ),
};

export const generateInput: () => Arbitrary<IDatiqInput> = () => {
    return record(inputRecordModel);
};

export const generateOption: () => Arbitrary<IDatiqOption> = () => {
    return record(IDatiqOptionRecordModel, {
        requiredKeys: ['display', 'value'],
    });
};

export const IDatiqOptionRecordModel: {
    [K in keyof IDatiqOption]: Arbitrary<IDatiqOption[K]>;
} = {
    display: string(),
    value: anything(),
    data: anything(),
    tooltip: string(),
    disabled: boolean(),
    tooltipPosition: string(),
    description: string(),
};
